module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/eb3a5f42-0255-4b85-82c6-bd5462a3928b-551652e095ea6198c7261b86182c28bf.png";